import * as Sentry from '@sentry/react'

// const attachmentUrlFromDsn = (dsn, eventId) => {
//   const { host, path, projectId, port, protocol, user } = dsn
//   return `${protocol}://${host}${port !== '' ? `:${port}` : ''}${
//     path !== '' ? `/${path}` : ''
//   }/api/${projectId}/events/${eventId}/attachments/?sentry_key=${user}&sentry_version=7&sentry_client=custom-javascript`
// }

const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'

export const initSentry = () => {
  const infra = process.env.REACT_APP_INFRA || 'dev'
  let environment = 'development'
  if (infra === 'uat') {
    environment = 'staging'
  } else if (infra === 'prod') {
    environment = 'production'
  }

  if (!isLocal) {
    Sentry.init({
      dsn: 'https://661fd2c79c6ab0f4cd4ac75d6e2fa9f0@o4510895913631744.ingest.de.sentry.io/4511060083408976',
      integrations: [Sentry.browserTracingIntegration()],

      enableAutoSessionTracking: true,
      environment,

      // Sessions close after app is 10 seconds in the background.
      sessionTrackingIntervalMillis: 10000,
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
    })
    Sentry.setTag('plateforme', 'excavator')
    Sentry.setTag('environment', environment)
  }
}

// eslint-disable-next-line no-unused-vars
export const captureMessageWithAttachment = (data, error) => {
  console.log('error capture')
  /*if (!isLocal) {
    const formData = new FormData()
    try {
      console.log('sending sentry', data, error)
      Sentry.withScope((scope) => {
        scope.setTransactionName(`pwa - ${data.request}`)
        const msgId = Sentry.captureMessage(`[GraphQL error]: ${error?.message}`)
        const client = Sentry.getCurrentHub().getClient()
        const endpoint = attachmentUrlFromDsn(client.getDsn(), msgId)
        formData.append(
          'my-attachment',
          // eslint-disable-next-line no-undef
          new Blob(
            [
              JSON.stringify({
                ...data,
                message: error?.message,
                url: window.location.href,
                accessToken: localStorage.getItem('access_token'),
                refreshToken: localStorage.getItem('refresh_token'),
              }),
            ],
            {
              type: 'application/json',
            }
          ),
          'logs.json'
        )
        if (navigator.onLine) {
          fetch(endpoint, {
            method: 'POST',
            body: formData,
          }).catch((ex) => {
            // we have to catch this otherwise it throws an infinite loop in Sentry
            console.error(ex)
          })
        } else {
          const localStorageSentryRequests = localStorage.getItem('sentry')
          if (localStorageSentryRequests) {
            const temp = JSON.parse(localStorageSentryRequests)
            setTimeout(() => {
              temp.push({ data, error })
              const tempSend = JSON.stringify(temp)
              setTimeout(() => {
                localStorage.setItem('sentry', tempSend)
              }, 1000)
            }, 1000)
          } else {
            const temp = JSON.stringify([{ data, error }])
            setTimeout(() => {
              localStorage.setItem('sentry', temp)
            }, 1000)
          }
        }
      })
    } catch (ex) {
      console.error(ex)
    }
  } */
}
